module.exports = __webpack_public_path__ + "static/Chernomorsk-d6bbf287a899b88ec0ec0d7e16b2eb65.png";